import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';


const PaymentSuccess = () => {

  const navigate = useNavigate();

  const headerGenerated = useHeaderGenerator(
    'Payment Successful 🎉',
    ' ',
    []
  );

  return (
    <>
      {headerGenerated}
        <Card>
          <Card.Body>
            <p>Your payment has been successfully processed!</p>
            <p>Your membership is now active and you’re ready to go.</p>
            <Alert variant="info">
              <p>We’ve sent you a confirmation email with your payment details. Please check your inbox (and spam folder) for the email.</p>
            </Alert>
            <h4>What’s next?</h4>
            <p>Book your next class, check the upcoming programme, and keep working towards your goals.</p>
            <Row>
              <Col>
                <Link to="/app/wod/timetable" className="me-2">
                  <button className="btn btn-sm btn-primary">Book a Class</button>
                </Link>
                <Link to="/app/wod/programming">
                  <button className="btn btn-sm btn-secondary">View Programme</button>
                </Link>
              </Col>
            </Row>
          </Card.Body>
        </Card>
    </>
  );
};

export default PaymentSuccess;
